import React, { useState } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
// import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

// const { SearchBar } = Search;
import { Row, Col, Form, Button, FormControl } from "react-bootstrap";

// Import Service
import FarmermasterService from "../../services/farmermaster.service";
import ModalEditStatus from "./ModalEditStatusMaster";
// import authService from "../../services/auth.service";

//Import DownloadPDF
import DownloadPDF from "./DownloadPdf";

//Import Modal
// import Modalapprove from "./Modalapprove";

// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";
moment.locale("th");

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

//import css
import "./listregsugarcane.css";

const ListRegsugarcane = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState("");
  const [master_id, setMaster_id] = useState(null);
  const [textSearch, setTextSearch] = useState("");
  //   const [farmerselect, farmerSetselect] = useState({});

  //   const user = authService.getCurrentUser();
  const getData = () => {
    setLoading(true);
    FarmermasterService.searchFarmerMaster({ textSearch: textSearch })
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const submitChangeStatus = (form) => {
    FarmermasterService.updateStatusMaster(form)
      .then((res) => {
        if (res.data.success) {
          setData((a) =>
            a.map((b) => {
              if (b.masterid == res.data.data.masterid) {
                return res.data.data;
              } else {
                return b;
              }
            })
          );
          setShow(false);
        }
      })
      .catch((err) => console.log(err));
  };
  const handleSearch = (e) => {
    e.preventDefault();
    getData();
  };
  const handleSearchChange = (e) => {
    setTextSearch(e.target.value);
  };
  const clickEdit = (row) => {
    console.log(row);
    setShow(true);
    setStatus(row.status_text);
    setMaster_id(row.masterid);
    // farmerSetselect({
    //   regsugar_id: row.regsugar_id,
    //   person_card_id: row.person_card_id,
    // });
    // setShow(true);
  };
  const ActionsEdit = (row) => {
    return (
      <>
        {row.row.approve_status == "อนุมัติ" ? (
          <i
            className="bi bi-pencil custom-icon-table"
            onClick={() => clickEdit(row.row)}
          ></i>
        ) : (
          "-"
        )}
      </>
    );
  };

  const actionsEdittFormatter = (cell, row) => {
    return <ActionsEdit row={row} />;
  };

  const columns = [
    {
      text: "masterid",
      dataField: "masterid",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "mastername",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "left",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "เลขประชาชน",
      dataField: "masteridcard",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "สถานะ",
      dataField: "status_text",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
      // style: {
      //   wordBreak: "break-word",
      // },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ผลการพิจารณา",
      dataField: "approve_status",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "อนุมัติโดย",
      dataField: "approve_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "เลข หน.กลุ่ม",
      dataField: "farmer_card",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      formatter: (cell) => {
        if (cell != "-") {
          return <DownloadPDF card={cell} />;
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
    },
    {
      text: "เริ่ม",
      dataField: "start_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
    },
    {
      text: "สิ้นสุด",
      dataField: "end_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
    },
    {
      text: "แก้ไข",
      dataField: "edit",
      isDummyField: true,
      editable: false,
      formatter: actionsEdittFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  if (error) return `Error :${error}`;

  return (
    <div>
      {loading ? <LoadingAlert /> : ""}
      <Row>
        <Col md={6}>
          <Form className="d-flex">
            <FormControl
              size="sm"
              type="search"
              placeholder="ค้นหาด้วย ชื่อ,นามสกุล,บัตรประชาชน,เลขชาวไร่อ้อย"
              className="me-2"
              aria-label="Search"
              onChange={handleSearchChange}
            />
            <Button variant="info" onClick={handleSearch} style={{ margin: 0 }}>
              ค้นหา
            </Button>
          </Form>
        </Col>
      </Row>
      <ModalEditStatus
        show={show}
        hidden={setShow}
        status={status}
        master_id={master_id}
        afterSubmit={submitChangeStatus}
      />
      {/* <Modalapprove
        show={show}
        hidden={(a) => setShow(a)}
        farmerselect={farmerselect}
      /> */}
      <ToolkitProvider
        bootstrap4
        keyField="masterid"
        data={data}
        columns={columns}
        search
      >
        {(prop) => (
          <React.Fragment>
            <div>
              <div className="text-left">
                {/* <button
                  className="btn btn-primary"
                  // onClick={handleClickAdd}
                  style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
                >
                  ตรวจสอบ
                </button> */}
                {/* <SearchBar {...prop.searchProps} /> */}
              </div>
            </div>
            <hr />
            <div style={{ width: "auto" }}>
              <BootstrapTable
                // selectRow={{
                //   mode: "checkbox",
                //   headerColumnStyle: {
                //     // textAlign: "center",
                //     width: "5%",
                //   },
                //   selectColumnStyle: {
                //     style: { background: "darkgray" },
                //   },
                // }}
                bootstrap4
                // keyField="masterid"
                columns={columns}
                data={data}
                pagination={pagination}
                //   cellEdit={cellEditFactory({
                //     mode: "click",
                //     blurToSave: true,
                //     afterSaveCell,
                //   })}
                filter={filterFactory()}
                // loading={true}
                {...prop.baseProps}
                // cellEdit={cellEditFactory({
                //   mode: "click",
                //   blurToSave: true,
                //   afterSaveCell: handleChange,
                //   beforeSaveCell: beforeSaveCell,
                // })}
              />
            </div>
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default ListRegsugarcane;
